var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookPages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1877F2",
    d: "M48 24a24 24 0 1 0-27.75 23.7V30.94h-6.1V24h6.1v-5.29c0-6.02 3.58-9.34 9.07-9.34 2.63 0 5.38.47 5.38.47v5.91h-3.03c-2.98 0-3.92 1.85-3.92 3.76V24h6.66l-1.07 6.94h-5.6V47.7A24 24 0 0 0 48 24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.34 30.94 34.4 24h-6.65v-4.5c0-1.9.93-3.76 3.92-3.76h3.03V9.83s-2.75-.47-5.38-.47c-5.49 0-9.07 3.33-9.07 9.34V24h-6.1v6.94h6.1V47.7a24.14 24.14 0 0 0 7.5 0V30.94h5.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookPages);
export default __webpack_public_path__ + "static/media/facebook-pages.1b8269491017653c83fbae545d7cac69.svg";
export { ForwardRef as ReactComponent };